import DateRangePicker from "../Common/DateTimeRangePicker";
import moment from 'moment';
import { Box, Button, Checkbox, Divider, Grid, ListItemText, makeStyles, MenuItem, TextField, Typography } from "@material-ui/core";
import { useEffect, useState, userPref } from "react";
import update from 'immutability-helper';
import { useTranslation } from "react-i18next";
import _ from 'lodash';
import InvestigationTable from "./InvestigationTable";
import { Autocomplete } from "@material-ui/lab";
import { useDispatch, useSelector } from "react-redux";
import { batchCloseIncident, getIncidentCount, searchIncidents } from "../../actions/incidentManagementActions";
import { handleOpenIncidentFormDialog, showAlertSnackbar } from "../../reducers/uiSlice";
import { useAlert } from "../../utilities/hooks";
import BatchInProgressForm from "./EditIncidentForm/InProgressForm/batchInprogress";
import UserAuthUpdate from '../../components/Common/UserAuthUpdate';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1
  },
  section: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    margin: '0px !important'
  },
  searchBar: {
    display: 'flex',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    rowGap: theme.spacing(1)
  },
  dateRangeRow: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: theme.spacing(2)
  },
  quickDateActions: {
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(3),
    padding: theme.spacing(2),
    paddingBottom: theme.spacing(2)
  },
  rowItem: {
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(3)
  },
  headerItem: {
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(3),
    flexWrap: 'wrap',
    padding: theme.spacing(4)
  },
  actionArea: {
    background: theme.palette.background.paper
  },
  warehouseSelect: {
    minWidth: 200,
    maxWidth: 300
  },
  badgeWithoutContent: {
    right: 'unset'
  },
  borderLeftOrTop: {
    borderColor: theme.palette.divider,
    borderStyle: 'solid',
    [theme.breakpoints.up('lg')]: {
      borderWidth: '0 0 0 1px',
    },
    [theme.breakpoints.down('md')]: {
      borderWidth: '1px 0 0 0',
    }
  },
  quickActionButton: {
    whiteSpace: 'nowrap',
    minWidth: 'auto',
  },
  filterTextField: {
    minWidth: 150,
    maxWidth: 240
  }
}));

const quickDateActionList = [
  {
    id: 1,
    label: "last_month",
    change_by: [
      {
        type: 'subtract',
        date_type: 'months',
        value: 1
      }
    ]
  },
  {
    id: 2,
    label: "last_two_month",
    change_by: [
      {
        type: 'subtract',
        date_type: 'months',
        value: 2
      }
    ]
  }
]

const initialFilterState = {
  status: -1,
  source: '',
  handler: '',
  investigationNumber: '',
  trackingNumber: '',
  driverId: '',
  incidentType: '',
  recordBy: '',
}

const initialInProgressFormState = {
  handler: null,
  caused_by: "",
  caused_by_detail: "",
  root_cause: "",
  root_cause_detail: "",
  result_type: "",
  result_detail: "",
  corrective_action: null,
  corrective_action_detail: "",
  notes: "",
}

function ParcelInvestigation(props) {
  const { onDataRefresh, refreshDataRequest, onFilterChange } = props;
  const dispatch = useDispatch();
  const classes = useStyles();
  const alertDialog = useAlert();
  const { t } = useTranslation('incidentManagement');

  const branchList = useSelector(state => state.common.branches);
  const userList = useSelector(state => state.common.users);
  const statusList = useSelector(state => state.incidentManagement.statusList);
  const investigationListLoading = useSelector(state => state.incidentManagement.investigationListLoading);
  const investigationList = useSelector(state => state.incidentManagement.investigationList);
  const investigationTableInfo = useSelector(state => state.incidentManagement.investigationTable);
  const incidentCount = useSelector(state => state.incidentManagement.incidentCount);
  const [inProgressInformation, setInProgressInformation] = useState({initialInProgressFormState});
  const [notes, setNotes] = useState("");
  const [dateRange, setDateRange] = useState({
    from: moment().startOf('day'),
    to: moment().endOf('day')
  });
  const [warehouse, setWarehouse] = useState([-1]);
  const [destination, setDestination] = useState(-1);
  const [closeReason, setCloseReason] = useState('');
  const [filter, setFilter] = useState(initialFilterState);
  const [savedFilter, setSavedFilter] = useState();
  const [selectedData, setSelectedData] = useState([]);
  const [batchInprogressModal, setBatchInprogressModal] = useState(false);

  const getWarehouseIncidentCount = (id) => {
    return _.find(incidentCount.warehouses, { 'location': id })?.total ?? 0
  }

  const handleDateChange = (event) => {
    let newValue = update(dateRange, {
      [event.target.id]: {
        $set: event.target.id === "from" ?
          moment(event.target.value).startOf('day')
          :
          moment(event.target.value).endOf('day')
      }
    });
    setDateRange(newValue)
  }

  const handleQuickDateAction = (actionItem) => {
    let newDate = moment()
    _.forEach(actionItem.change_by, (changeBy) => {
      newDate[changeBy.type](changeBy.value, changeBy.date_type)
    })
    let newState = update(dateRange, { from: { $set: newDate.endOf('day') } });
    setDateRange(newState)
  }

  const handleWarehouseChange = (event) => {
    let valueArray = event.target.value
    //-1 is selection for all, since 0 is taken by a hidden area
    if (_.last(valueArray) === -1) {
      valueArray = [-1]
    } else {
      _.pull(valueArray, -1)
    }
    setWarehouse(valueArray)
  }

  const handleFilterChange = (event) => {
    setFilter({ ...filter, [event.target.name]: event.target.value });
  };

  const handleBatchClose = async () => {
    let params = {
      review_type: closeReason,
      incident_ids: selectedData,
    }
    try {
      let responseData = await dispatch(batchCloseIncident(params));
      let successList = [];
      let failList = [];
      _.forEach(responseData, (value) => {
        if (value.success) {
          successList.push(value.id)
        } else {
          failList.push(value.id)
        }
      })

      alertDialog.addAlertDialog(
        t('dialog:incident_batch_close'),
        [
          t('dialog:incident_batch_close_message'),
          `Failed: ${failList.length > 0 ? failList.join(", ") : "None"}`,
          `Success: ${successList.length > 0 ? successList.join(", ") : "None"}`
        ], null,
        t('common:ok'),
        () => {
          handleSearch();
          setSelectedData([]);
          alertDialog.hideAlert();
        }
      );
      alertDialog.showAlert();
    } catch (error) {
      alertDialog.addAlertDialog(
        t('dialog:incident_batch_close'),
        error.message
      );
      alertDialog.showAlert();
    }
  }

  const _searchIncidents = (page = 1, rowPerPage = 20) => (pagination = false) => {
    let param = makeFilterParams();
    //This is used for pagination since we don't want filters to change during pagination
    if (pagination) {
      param = savedFilter
    }
    param["page"] = page;
    dispatch(searchIncidents(param)).then(data => {
      let total = data?.total ?? 0;
      if (total <= 0) {
        dispatch(showAlertSnackbar({
          title: t('incident_management'),
          message: t('dialog:advanced_search_no_order')
        }));
      }
      setSavedFilter(param)
    }).catch(error => {
      console.error(error)
      dispatch(showAlertSnackbar({
        title: t('incident_management'),
        message: error.message
      }))
    })
    //Used to notify parent about data refresh
    onDataRefresh();
  }

  const handleSearchPagination = (page, rowPerPage) => _searchIncidents(page, rowPerPage)(true);
  const handleSearch = (page, rowPerPage) => _searchIncidents(page, rowPerPage)(false);

  const makeFilterParams = () => {
    return {
      from_date: dateRange.from.unix(),
      to_date: dateRange.to.unix(),
      status: filter.status || null,
      source: filter.source || null,
      handler: filter.handler || null,
      investigation_no: filter.investigationNumber || null,
      tracking_no: filter.trackingNumber || null,
      driver_id: filter.driverId || null,
      recorded_by: filter.recordBy || null,
      incident_type: filter.incidentType || null,
      area: warehouse,
      destination_warehouse: [destination]
    }
  }
  
  const handleFormChange = (event, stateName, setState) => {
    let value = event.target.value;
    if(event.target.type === "date"){
      value = moment(event.target.value).unix();
    }
    if(event.target.name === "notes"){
      handleNotesChange(value);
    } else if(event.target.name){
      setState({ ...stateName, [event.target.name]: value });
    }
  };

  const handleNotesChange = (text) => {
    setNotes(text);
  }
  
  const refreshData = (page) => {
    handleSearchPagination(page)
    dispatch(getIncidentCount())
  }

  useEffect(() => {
    if (refreshDataRequest && investigationList.length > 0) {
      let currentPage = investigationTableInfo?.currentPage ?? 1
      console.log(`Detected update to form information: Refreshing page ${currentPage}`)
      refreshData(currentPage)
    }
  }, [refreshDataRequest])

  useEffect(() => {
    onFilterChange(makeFilterParams());
  }, [dateRange, filter])

  return (
    <Box className={classes.root}>
      <UserAuthUpdate/>
      <div className={classes.searchBar}>
        <Grid container>
          <Grid item xs={12} sm={12} md={12} lg={10}>
            <div className={classes.headerItem}>
              <DateRangePicker
                className={classes.dateRangeRow}
                fromDateValue={dateRange.from}
                toDateValue={dateRange.to}
                textFieldStyle={{
                  minWidth: 236,
                  flex: 1
                }}
                handleDateChange={handleDateChange}
              />
              <div className={classes.rowItem}>
                {quickDateActionList.map(item => (
                  <Button
                    className={classes.quickActionButton}
                    id={`date-quick-select-${item.id}`}
                    key={`date-quick-select-${item.id}`}
                    variant="contained"
                    onClick={() => handleQuickDateAction(item)}
                    color="secondary"
                    fullWidth
                  >
                    {t(item.label)}
                  </Button>
                ))}
              </div>
              <Divider orientation="vertical" flexItem />
              <TextField
                id='select-investigation-status'
                label={t('investigation_status')}
                name="status"
                variant="outlined"
                value={filter.status}
                defaultValue={-1}
                onChange={handleFilterChange}
                select
                fullWidth
                style={{ width: 166 }}
              >
                <MenuItem value={-1}>{t('common:all')}</MenuItem>
                {
                  statusList.incidentStatusList.map((status, index) => {
                    return <MenuItem key={index} value={status.id}>
                      {status.name}
                    </MenuItem>
                  })
                }
              </TextField>
              <TextField
                id="input-source"
                className={classes.filterTextField}
                label={t("start_from")}
                name="source"
                variant="outlined"
                defaultValue={-1}
                value={filter.source}
                onChange={handleFilterChange}
                select
                fullWidth
              >
                <MenuItem value={-1}>{t('common:all')}</MenuItem>
                {
                  statusList.sourceList.map((source, index) => {
                    return <MenuItem key={index} value={source.id}>
                      {source.name}
                    </MenuItem>
                  })
                }
              </TextField>
              <TextField
                id='select-area'
                className={classes.warehouseSelect}
                defaultValue={[-1]}
                label={t('current_warehouse')}
                variant="outlined"
                select
                fullWidth
                style={{ minWidth: 250, maxWidth: 505 }}
                SelectProps={{
                  multiple: true,
                  value: warehouse,
                  onChange: handleWarehouseChange,
                  renderValue: (selected) => _.map(selected, (value) => {
                    let find = _.find(branchList, { 'id': value })
                    return (find && find['name']) || t('common:all')
                  }).join(', ')
                }}
              >
                <MenuItem value={-1}>{t('common:all')}</MenuItem>
                {
                  branchList && branchList.map((branch, index) => {
                    return <MenuItem key={index} value={branch.id}>
                      <Checkbox checked={warehouse.indexOf(branch.id) > -1} />
                      <ListItemText primary={`${branch.name} (${getWarehouseIncidentCount(branch.id)})`} />
                    </MenuItem>
                  })
                }
              </TextField>
              <TextField
                id='select-destination-warehouse'
                className={classes.warehouseSelect}
                label={t('warehouse')}
                defaultValue={-1}
                variant="outlined"
                select
                fullWidth
                value={destination}
                onChange={(e) => setDestination(e.target.value)}
              >
                <MenuItem value={-1}>{t('common:all')}</MenuItem>
                {
                  branchList && branchList.map((branch, index) => {
                    return <MenuItem key={index} value={branch.id}>
                      <ListItemText primary={branch.name} />
                    </MenuItem>
                  })
                }
              </TextField>
              <Autocomplete
                id="autocomplete-handled-by"
                className={classes.filterTextField}
                name="handler"
                options={userList}
                getOptionLabel={(option) => option?.username || "error"}
                renderInput={(params) => <TextField {...params} label={t('handled_by')} variant='outlined' />}
                fullWidth
                value={_.find(userList, { 'id': filter.handleBy || "" })}
                onChange={(event, newValue) => {
                  event.target.name = "handler"
                  event.target.value = newValue?.id //we want the id instead of the default index
                  handleFilterChange(event) //set for actual data change
                }}
              />
              <Autocomplete
                id="autocomplete-recoreded-by"
                className={classes.filterTextField}
                name="recordBy"
                options={userList}
                getOptionLabel={(option) => option?.username || "error"}
                renderInput={(params) => <TextField {...params} label={t('recorded_by')} variant='outlined' />}
                fullWidth
                value={_.find(userList, { 'id': filter.recordBy || "" })}
                onChange={(event, newValue) => {
                  event.target.name = "recordBy"
                  event.target.value = newValue?.id //we want the id instead of the default index
                  handleFilterChange(event) //set for actual data change
                }}
              />
              <TextField
                id='input_incident_type'
                className={classes.filterTextField}
                label={t('incident_type')}
                name="incidentType"
                variant="outlined"
                value={filter.incidentType}
                defaultValue={-1}
                onChange={handleFilterChange}
                select
                fullWidth
                style={{ width: 250 }}
              >
                <MenuItem value={-1}>{t('common:all')}</MenuItem>
                {
                  statusList.incidentTypeList.map((incident_type, index) => {
                    return <MenuItem key={index} value={incident_type.id}>
                      {incident_type.name}
                    </MenuItem>
                  })
                }
              </TextField>
              <TextField
                id="input_driver_id"
                className={classes.filterTextField}
                label={t("serch_by_driver")}
                name="driverId"
                variant="outlined"
                onChange={handleFilterChange}
                fullWidth
                style={{ width: 100 }}
              />
              <TextField
                id="input_investigation_number"
                className={classes.filterTextField}
                label={t("investigation_number")}
                name="investigationNumber"
                variant="outlined"
                onChange={handleFilterChange}
                fullWidth
              />
              <TextField
                id="input_tracking_number"
                className={classes.filterTextField}
                label={t("common:tracking_number")}
                name="trackingNumber"
                variant="outlined"
                onChange={handleFilterChange}
                fullWidth
              />
              <Button
                id='button-search'
                variant="contained"
                color="secondary"
                onClick={() => handleSearch()}
              >
                {t('common:search')}
              </Button>
            </div>
          </Grid>
          <Grid item className={`${classes.borderLeftOrTop} ${classes.actionArea}`} xs={12} sm={12} md={12} lg={2}>
            <div className={classes.headerItem}>
              <TextField
                id='select-review-close'
                label={t('review_and_close')}
                variant="outlined"
                defaultValue=""
                value={closeReason}
                onChange={(event) => setCloseReason(event.target.value)}
                select
                fullWidth
                InputLabelProps={{
                  shrink: true,
                }}
                SelectProps={{
                  displayEmpty: true,
                  renderValue: (selected) => {
                    if (selected === '') {
                      return t('select_close_reason')
                    }
                    let find = _.find(statusList.reviewTypeList, { 'id': selected })
                    return (find && find['name']) || selected
                  }
                }}
              >
                {
                  statusList.reviewTypeList.map((reason, index) => {
                    return <MenuItem key={index} value={reason.id}>
                      {reason.name}
                    </MenuItem>
                  })
                }
              </TextField>
              <Button
                id='button-close-investigation'
                variant="contained"
                color="primary"
                disabled={closeReason === '' || selectedData.length <= 0}
                onClick={handleBatchClose}
                fullWidth
              >
                {t('close_investigation')}
              </Button>
              <Typography color="textPrimary">
                {t('batch_inprogress')}
              </Typography>
              <Button
                id='button-close-investigation'
                variant="contained"
                color="primary"
                disabled={selectedData.length <= 0}
                onClick={setBatchInProgress}
                fullWidth
              >
                {t('batch_inprogress')}
              </Button>
            </div>
          </Grid>
        </Grid>
      </div>
      <div style={{ display: 'flex', flexGrow: 1 }}>
        <InvestigationTable
          data={investigationList}
          branchList={branchList}
          statusList={statusList}
          userList={userList}
          tableInfo={investigationTableInfo}
          loading={investigationListLoading}
          onSelectionModelChange={(model) => setSelectedData(model)}
          handleSearch={handleSearchPagination}
          openIncidentForm={(params) => dispatch(handleOpenIncidentFormDialog(params))}
        />
      </div>
      <BatchInProgressForm
        className={classes.section}
        data={inProgressInformation}
        open={batchInprogressModal}
        onClose={(isUpdated) => {
          setBatchInProgress(false);
          if(isUpdated){
            handleSearch();
            setSelectedData([]);
            setInProgressInformation(initialInProgressFormState);
          }
        }}
        branchList={branchList}
        userList={userList}
        statusList={statusList}
        inidentIds={selectedData}
        onFormChange={(event) => handleFormChange(event, inProgressInformation, setInProgressInformation)}
        maxWidth="md"
        disableDefaultButtons
        fullWidth
      />
    </Box>
  )

  function setBatchInProgress(close) {
    setBatchInprogressModal(close);
  }
}

ParcelInvestigation.defaultProps = {
  onDataRefresh: () => { },
  onFilterChange: () => { },
  refreshDataRequest: [],
}

export default ParcelInvestigation;